import { ApolloClient, ApolloLink, createHttpLink, defaultDataIdFromObject, InMemoryCache, Operation } from "@apollo/client";
import { CombinedGraphQLErrors, LinkError } from "@apollo/client/errors";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import * as Sentry from "@sentry/react";
import { map } from "rxjs/operators";
import { authenticationActions } from "../redux/authentication/slice";
import { store } from "../redux/store";
import { getToken } from "../utils/utils";

const isBodyTextAuthError = (errorObject: any) => {
  console.log(errorObject);
  const errorText = errorObject?.bodyText || errorObject?.result;
  if (!errorText) return false;
  return errorText?.toLocaleLowerCase().includes("token");
};

const errorLink = onError(({ error, operation }) => {
  if (CombinedGraphQLErrors.is(error)) {
    error.errors.forEach((gqlError) => {
      console.log(
        `[GraphQL error]: Message: ${gqlError.message}, Location: ${JSON.stringify(gqlError.locations)}, Path: ${gqlError.path}`
      );
      Sentry.captureException(gqlError, { extra: { operation } });
    });
  }

  if (LinkError.is(error)) {
    const errorObject = JSON.parse(JSON.stringify(error));
    console.log(`[Network error]: Message: ${error.message}, Stack: ${error.stack}`);
    Sentry.captureException(error, { extra: { operation, errorObject } });

    if (isBodyTextAuthError(errorObject)) {
      store.dispatch(authenticationActions.update({ loggedInUser: undefined, isLoggedIn: false }));
    }
  }
});

const timeStartLink = new ApolloLink((operation, forward) => {
  operation.setContext({ start: Date.now() });
  return forward(operation);
});

const logTimeLink = new ApolloLink((operation, forward) => {
  return forward(operation).pipe(map((data) => {
    const time = Date.now() - operation.getContext().start;
    console.log(`operation ${operation.operationName} took ${time} milliseconds to complete`);
    return data;
  }));
});

/**
 * Authorization and Address middleware
 *
 * Retrieve auth token from async storage {retrieveToken fuc}.
 *
 * Set auth headers { Authorization: `Bearer ${token}`,}
 */
const middleware = setContext(async (_, { headers }) => {
  const token = getToken();
  console.log(token);
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const privateLink = createHttpLink({
  uri: "//api.bidscape.com/graphql",
});

const publicLink = createHttpLink({
  uri: "//api.bidscape.com/graphql/public",
});

const usePublicLink = (operation: Operation) => {
  return operation.getContext().public;
};

const httpLink = ApolloLink.split(usePublicLink, publicLink, privateLink);

const link = ApolloLink.from([timeStartLink, logTimeLink, errorLink, middleware, httpLink]);

const cache = new InMemoryCache({
  dataIdFromObject(responseObject) {
    switch (responseObject.__typename) {
      case "CartItem":
        return `CartItem:${JSON.stringify(responseObject)}`;
      default:
        return defaultDataIdFromObject(responseObject);
    }
  },
});

export const client = new ApolloClient({
  cache,
  link,
  defaultOptions: {
    query: {
      errorPolicy: "all",
      fetchPolicy: "network-only",
    },
    watchQuery: {
      notifyOnNetworkStatusChange: true,
    },
  },
});
